import type { finance as financeEn } from "../en/finance";

export const finance: typeof financeEn = {
  overview: {
    title: "Platby a marže",
    subtitle: "Pohledávky, závazky a export do Pohody",
    from: "Od",
    to: "Do",
    receivables: "Pohledávky",
    overdueAr: "Po splatnosti (pohledávky)",
    payables: "Závazky",
    overdueAp: "Po splatnosti (závazky)",
    openInvoices_one: "{{count}} otevřená faktura",
    openInvoices_few: "{{count}} otevřené faktury",
    openInvoices_other: "{{count}} otevřených faktur",
    supplierInvoices_one: "{{count}} dodavatelská faktura",
    supplierInvoices_few: "{{count}} dodavatelské faktury",
    supplierInvoices_other: "{{count}} dodavatelských faktur",
    accountsReceivable: "Pohledávky",
    accountsPayable: "Závazky",
    nothingOutstanding: "Žádné nezaplacené faktury 🎉",
    nothingToPay: "Není co platit",
    dueOn: "Splatnost {{date}}",
    dueOnInline: "splatnost {{date}}",
    noDueDate: "Bez data splatnosti",
    overdue: "po splatnosti",
    supplierFallback: "Dodavatel",
  },
  invoices: {
    title: "Faktury",
    subtitle: "Vydané faktury — proformy, finální faktury, dobropisy",
    searchPlaceholder: "Hledat podle čísla faktury…",
    empty: "Žádné faktury",
    number: "Číslo",
    order: "Objednávka",
    due: "Splatnost",
    openPdf: "Otevřít PDF",
  },
  vouchers: {
    title: "Dárkové poukazy",
    subtitle: "Správa dárkových poukazů",
    loadError: "Poukazy se nepodařilo načíst. Zkuste to prosím znovu.",
    searchPlaceholder: "Hledat podle kódu, jména nebo e-mailu…",
    empty: "Žádné poukazy nebyly nalezeny",
    stats: {
      total: "Celkem",
      active: "Aktivní",
      used: "Uplatněné",
      activeValue: "Hodnota aktivních",
    },
    filters: {
      all: "Vše",
      active: "Aktivní",
      used: "Uplatněné",
      expired: "Propadlé",
    },
    statuses: {
      active: "Aktivní",
      used: "Uplatněný",
      expired: "Propadlý",
    },
    table: {
      code: "Kód",
      amount: "Částka",
      buyer: "Kupující",
      recipient: "Příjemce",
      expires: "Platnost do",
    },
    expiringSoon: "Brzy vyprší",
    viewDetails: "Zobrazit detail",
    resendEmail: "Znovu odeslat e-mail",
    detail: {
      notFound: "Poukaz nebyl nalezen nebo se nepodařilo načíst data.",
      backToList: "Zpět na poukazy",
      title: "Poukaz {{code}}",
      created: "Vytvořeno {{date}}",
      detailsTitle: "Detail poukazu",
      usedAt: "Uplatněno",
      lastEmailSent: "Poslední odeslaný e-mail",
      buyer: "Kupující",
      recipient: "Příjemce",
      recipientNamePlaceholder: "Jméno příjemce",
      recipientEmailPlaceholder: "E-mail příjemce",
      personalMessage: "Osobní vzkaz",
    },
  },
  premiumUpgrades: {
    title: "Prémiové upgrady",
    subtitle: "Správa prémiových upgradů k zájezdům",
    newUpgrade: "Nový upgrade",
    searchPlaceholder: "Hledat upgrady…",
    empty: "Žádné prémiové upgrady nebyly nalezeny",
    badge: "Štítek",
    noImage: "Bez obrázku",
    confirmDelete: "Opravdu chcete tento upgrade smazat?",
    badges: {
      popular: "OBLÍBENÉ",
      ourTip: "NÁŠ TIP",
      discount: "SLEVA",
      new: "NOVINKA",
    },
    form: {
      newTitle: "Nový prémiový upgrade",
      editTitle: "Upravit prémiový upgrade",
      newSubtitle: "Vytvořte novou možnost upgradu",
      editingSubtitle: "Úprava: {{title}}",
      notFound: "Upgrade nenalezen",
      titlePlaceholder: "např. Upgrade letu do business třídy",
      descriptionPlaceholder: "Popište upgrade…",
      noBadge: "-- Bez štítku --",
    },
  },
};
